export const GET_ALL_STYLES = 'GET_ALL_STYLES';

export const UPDATE_THEME = 'UPDATE_THEME';

export const UPDATE_BACKGROUND = 'UPDATE_BACKGROUND';

export const UPDATE_TEXT_COLOR = 'UPDATE_TEXT_COLOR';

export const UPDATE_BUTTON = 'UPDATE_BUTTON';

export const UPDATE_IMAGE_LINK = 'UPDATE_IMAGE_LINK';

export const UPDATE_SHOW_FOOTER = 'UPDATE_SHOW_FOOTER';



// WEBPACK FOOTER //
// ./src/store/modules/styles/types.js